module.exports = __webpack_public_path__ + "static/media/Sample.0d426f86.pdf";